import { Box, Theme } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  primaryButton: React.ReactNode
  secondaryButton?: React.ReactNode
  useLightBackground?: boolean
  sxFooter?: object
}

const SensorActivationFooter = (props: IProps) => {
  const { primaryButton, secondaryButton, useLightBackground = false, sxFooter } = props
  const classes = useStyles

  return (
    <Box
      sx={(theme: Theme) => ({
        ...classes.footer(theme),
        ...(useLightBackground && classes.lightBackgroundFooter(theme)),
        ...(sxFooter || {}),
      })}
    >
      {primaryButton}
      {secondaryButton}
    </Box>
  )
}

export default SensorActivationFooter
